export class ClientConfig {
  constructor(config, id) {
    this.id = id;
    if (!config) {
      this.intake = {};
      this.priorAuth = {};
      this.submissionMethod = null;
      this.key = null;
      return;
    }
    this.intake = { ...config.uiConfig.intake };
    this.priorAuth = { ...config.uiConfig.priorAuth };
    this.submissionMethod = config.uiConfig?.submissionMethod;
    this.key = config.uiConfig.key;
    this.defaultPostLoginPage = config.uiConfig?.defaultPostLoginPage || "all-submissions";
    this.kanbanViewEnabled = config.uiConfig?.kanbanViewEnabled ?? true;
  }
}
